import { render, staticRenderFns } from "./DeviceStock.vue?vue&type=template&id=ba5c1c20&scoped=true&"
import script from "./DeviceStock.vue?vue&type=script&lang=js&"
export * from "./DeviceStock.vue?vue&type=script&lang=js&"
import style0 from "./DeviceStock.vue?vue&type=style&index=0&id=ba5c1c20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5c1c20",
  null
  
)

export default component.exports